import * as React from "react";
const SvgIcHomeFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15 23H23V10.2914L12 1L1 10.2914V23H9V15H15V23Z" fill="currentColor" /></svg>;
export default SvgIcHomeFilled;